<script>
    import { Link } from 'svelte-routing'

    import { Spinner, Container, Row, Col, Button } from 'sveltestrap'
    import TaskCard from '../../components/TaskCard.svelte'
    import SubTaskCard from '../../components/SubTaskCard.svelte'
    import LocationMap from '../../components/LocationMap.svelte'

    import date from 'date-and-time'
    import { Tasks } from '../../middleware/database/tasks'

    export let id = null
    export let location = null

    let loading = true
    let task = {}

    $: if (loading) {

        Tasks.findOne(id)
            .then(doc => {
                task = doc
                loading = false
            })
            .catch(err => {
                console.log(`Error occured while fetching Task from Firestore. ${err}`)
            })
    }

</script>

<style>
    .subtaskContainer {
        background-color: #fff;
    }
</style>

{#if loading}
    <Spinner size="lg" color="dark" type="grow" />
{:else}
    <Container class="mt-4">
        <Row>
            <Col><Link to="/tasks"><i class="fa fa-arrow-left"></i><span style="margin-left: 8px">Back</span></Link></Col>
        </Row>
        <Row>
            <Col>
                <TaskCard {task} />
            </Col>
            <Col>
                <div class="subtaskContainer">
                <Container>
                    <Row class="pt-3">
                        <Col>
                            <LocationMap geopoint={(task.geolocation) ? task.geolocation : ''}/>
                        </Col>
                    </Row>
                    <Row class="mt-3">
                        <Col>
                            <h5 class="float-left">Subtasks</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {#if (task.subtasks)}
                                {#each task.subtasks as subtask}
                                    <SubTaskCard class="mb-3" {subtask} taskId={task.id}/>
                                {/each}
                            {:else}
                                <SubTaskCard class="mb-3" subtask={{id: 0}} taskId={null}/>
                            {/if}
                        </Col>
                    </Row>
                </Container>
                </div>
            </Col>
        </Row>
    </Container>
{/if}